import { ApiClient } from '../ApiClient';

export abstract class AbstractService {
	// eslint-disable-next-line no-empty-function
	constructor(protected readonly client: ApiClient) {}
}
